import { tracer as i } from "@forge-ui-components/tracing-client";
const c = { moduleName: "TagAndIntrestDataLoader" }, d = async () => {
  var e;
  return (e = window.JwtService) == null ? void 0 : e.getJwt();
}, h = async (e, a) => {
  const o = "/funl/tags/interests", r = await d();
  try {
    const t = await fetch(o, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...r && { Authorization: `Bearer ${r}` }
      },
      body: JSON.stringify(e)
    });
    if (!t.ok) {
      const s = await t.text(), { status: n } = t;
      throw new Error(`Post request failed with status: ${n} and error: ${s}`);
    }
    return await t.json();
  } catch (t) {
    return i.log.error(`${t}`, c), a(!0), Promise.reject(t);
  }
}, l = async (e, a, o) => {
  const r = await d();
  try {
    const t = await fetch(e, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        ...r && { Authorization: `Bearer ${r}` }
      },
      body: JSON.stringify(a)
    });
    if (!t.ok) {
      const s = await t.text(), { status: n } = t;
      throw new Error(`Post request failed with status: ${n} and error: ${s}`);
    }
    return await t.json();
  } catch (t) {
    return i.log.error(`${t}`, c), o(!0), Promise.reject(t);
  }
}, f = async (e, a) => {
  const o = `/funl/interests/${e}`, r = await d();
  try {
    const t = await fetch(o, {
      method: "DELETE",
      credentials: "include",
      headers: {
        ...r && { Authorization: `Bearer ${r}` }
      }
    });
    if (!t.ok) {
      const s = await t.text(), { status: n } = t;
      throw new Error(`Post request failed with status: ${n} and error: ${s}`);
    }
    return await t.json();
  } catch (t) {
    return i.log.error(`${t}`, c), a(!0), Promise.reject(t);
  }
};
export {
  h as getInterestDetailsForTag,
  l as putInterest,
  f as removeInterestData
};
//# sourceMappingURL=index.es4.js.map
